import { create } from 'zustand';

import type { NotionFormKind } from '@/shared/constants/externalLinks';

interface NotionFormModalOptions {
    kind: NotionFormKind;
    title?: string;
}

interface NotionFormModalState {
    open: boolean;
    kind: NotionFormKind;
    title?: string;
    show: (options: NotionFormModalOptions) => void;
    hide: () => void;
}

export const useNotionFormModalStore = create<NotionFormModalState>((set) => ({
    open: false,
    kind: 'support',
    show: (options) => set({ open: true, kind: options.kind, title: options.title }),
    hide: () => set({ open: false, title: undefined }),
}));

export const openNotionFormModal = (kind: NotionFormKind, title?: string): void => {
    useNotionFormModalStore.getState().show({ kind, title });
};

export const closeNotionFormModal = (): void => {
    useNotionFormModalStore.getState().hide();
};
